export default __webpack_public_path__ + "static/media/stop-icon.ac7d3732.svg";